import { Box, Flex, customStyled } from '@mafc/trolly';
import OrderSummaryRow from 'common/OrderSummary/components/OrderSummaryRow';
import MQ from 'theme/breakpoints';
import SPACINGS from 'theme/spacings';

export const StyledBox = customStyled(Box)(({ theme }) => ({
  backgroundColor: theme.colors.white,
  marginBottom: theme.space[4],
  borderRadius: theme.space[2],
  padding: theme.space[2],
  paddingTop: SPACINGS[12],
  paddingBottom: SPACINGS[12],
  [MQ[0]]: {
    padding: theme.space[3],
  },
}));

export const StyledOrderSummaryRow = customStyled(OrderSummaryRow)({
  marginBottom: 0,
});

export const TotalSavingsLabel = customStyled(Flex)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  columnGap: '0.75rem',
  fontWeight: theme.fontWeights[3],
}));
